import EmptyQueryBoundary from "./components/EmptyQueryBoundary";
import Hit from "./components/Hit";
import HitContainer from "./components/HitContainer";
import InputBox from "./components/InputBox";
import NoResults from "./components/NoResults";
import NoResultsBoundary from "./components/NoResultsBoundary";
import PopularQueries from "./components/PopularQueries";
import RefinementList from "./components/RefinementList";
import { useSearchClient } from "./hooks";

const Search = {
    NoResults,
    RefinementList,
    PopularQueries,
    Hit,
    HitContainer,
    InputBox,
    EmptyQueryBoundary,
    NoResultsBoundary
};

export { Search, useSearchClient };
